export default __webpack_public_path__ + "static/media/downloadIcon.f9947edf.svg";